module.exports = __webpack_public_path__ + "static/media/vitalInsuranceBuy2.1d847cc9.png";